// Demo-only (am-tp-demo user groups) — delete after the TP demo. Not a real-feature surface.
import {
  CreateAffiliateUserGroupProps,
  TAffiliateApiErrorPayload,
  TAffiliateUserGroup,
  TAffiliateUserGroupResponse,
} from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function createAffiliateUserGroup(
  affiliateFirmId: string,
  props: CreateAffiliateUserGroupProps
): Promise<{ success: boolean; data?: TAffiliateUserGroup; error?: string }> {
  try {
    const response = await fetcher(
      `demo/affiliate-firms/${affiliateFirmId}/user-groups`,
      {
        method: 'POST',
        body: props,
      }
    );

    if (!response.ok) {
      const payload: TAffiliateApiErrorPayload = await response
        .json()
        .catch(() => ({}));
      const message = Array.isArray(payload.message)
        ? payload.message.join(', ')
        : payload.message;
      return {
        success: false,
        error: message ?? 'Could not create the group.',
      };
    }

    const payload: TAffiliateUserGroupResponse = await response.json();
    return { success: true, data: payload.userGroup };
  } catch (error) {
    return { success: false, error: 'Could not create the group.' };
  }
}
